// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__34hF6","col":"CardReaderDesc_col__2HD7z","label":"CardReaderDesc_label__1VVxa"};